let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hloRW")).then(() => parcelRequire('2lY4S'));